// extracted by mini-css-extract-plugin
export var benefit = "SectionBenefits-module--benefit--aa60b";
export var benefitGroup = "SectionBenefits-module--benefit-group--96f60";
export var benefitGroups = "SectionBenefits-module--benefit-groups--d8e6b";
export var benefitText = "SectionBenefits-module--benefit-text--b8b01";
export var groupTitle = "SectionBenefits-module--group-title--003f5";
export var groupTitleSection = "SectionBenefits-module--group-title-section--28c8f";
export var sectionTitleHeading = "SectionBenefits-module--section-title-heading--c29a0";